import Vue from 'vue'
import projectLabelApi from '@/api/projectLabel.api'

const state = {
  labels: {}
}


const getters = {
  projectLabelById: (state) => (id) => {
    return state.labels[id]
  },

  projectLabels: (state) => {
    return Object.values(state.labels) || []
  }
}


const actions = {
  async loadProjectLabels ({ commit, state, rootState }) {
    const response = await projectLabelApi.getLabels(rootState.tenant.current)
    commit('SET_LABELS', response.data)
  },

  async createProjectLabel ({ commit, rootState }, label) {
    const response = await projectLabelApi.createLabel(rootState.tenant.current, label)
    commit('CREATE_LABEL', response.data)
  },

  async updateProjectLabel ({ commit, dispatch, rootState }, label) {
    await projectLabelApi.updateLabel(rootState.tenant.current, label.id, label)
    commit('UPDATE_LABEL', label)
  },

  async deleteProjectLabel ({ commit, dispatch, rootState }, id) {
    await projectLabelApi.deleteLabel(rootState.tenant.current, id)
    commit('DELETE_LABEL', id)
    dispatch('project/removeLabelFromAllProjects', id, { root: true })
  }
}


const mutations = {
  SET_LABELS (state, labels) {
    state.labels = {}
    for (const label of labels) {
      Vue.set(state.labels, label.id, label)
    }
  },

  CREATE_LABEL (state, label) {
    Vue.set(state.labels, label.id, label)
  },

  UPDATE_LABEL (state, label) {
    Vue.set(state.labels, label.id, label)
  },

  DELETE_LABEL (state, id) {
    Vue.delete(state.labels, id)
  }
}


export default {
  state,
  getters,
  actions,
  mutations
}
